// One vendor in the browser list. Click to select / request a quote.

export default function VendorCard({ vendor, selected, onSelect }) {
  return (
    <button
      type="button"
      className={`s-vendor${selected ? " picked" : ""}`}
      onClick={() => onSelect?.(vendor)}
      style={{ textAlign: "left" }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
        {vendor.photo_url ? (
          <img
            src={vendor.photo_url}
            alt={vendor.name}
            style={{ width: 36, height: 36, borderRadius: "50%", objectFit: "cover", flexShrink: 0, border: "1px solid #e1ede7" }}
          />
        ) : (
          <div style={{ width: 36, height: 36, borderRadius: "50%", flexShrink: 0, background: "#eef5f1", color: "#7aad98", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'DM Mono',monospace", fontSize: 13, fontWeight: 700 }}>
            {(vendor.name || "?").slice(0, 1).toUpperCase()}
          </div>
        )}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 8, flex: 1, minWidth: 0 }}>
          <div className="s-vendor-name">{vendor.name}{selected ? " ✓" : ""}</div>
          {vendor.rating != null && (
            <div style={{ fontFamily: "'DM Mono',monospace", fontSize: 11, color: "#c47c1a", flexShrink: 0 }}>
              ★ {vendor.rating} · {vendor.review_count || 0}
            </div>
          )}
        </div>
      </div>
      {vendor.blurb && (
        <div style={{ fontSize: 12, color: "#5b7365", lineHeight: 1.5, marginBottom: 6 }}>
          {vendor.blurb}
        </div>
      )}
      <div className="s-vendor-meta">
        {vendor.lead_time_days != null && `${vendor.lead_time_days}d lead`}
        {vendor.base_pricing && Object.keys(vendor.base_pricing).length > 0 &&
          ` · from $${Math.min(...Object.values(vendor.base_pricing).filter(v => typeof v === "number")).toLocaleString()}`}
      </div>
    </button>
  );
}
